import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader, ComponentFooter } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/form-note/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
        # Get package information by NPM package name.
        packageTable: thumbprintComponent(name: { eq: "@thumbtack/thumbprint-scss" }) {
            ...PackageTableFragment
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Examples`}</h2>
    <p><inlineCode parentName="p">{`aria-describedby`}</inlineCode>{` should be used to `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/WCAG20-TECHS/ARIA1.html#ARIA1-ex2"
      }}>{`associate form fields with form notes`}</a>{`. The value of `}<inlineCode parentName="p">{`aria-describedby`}</inlineCode>{` must match the form note’s `}<inlineCode parentName="p">{`id`}</inlineCode>{`.`}</p>
    <h3>{`Basic form note`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<label class="tp-label" for="input-2781013281341440">Password</label>
<input
    type="password"
    class="tp-text-input"
    id="input-2781013281341440"
    aria-describedby="password-form-note"
/>
<div id="password-form-note" class="tp-form-note">
    Passwords must be at least 8 characters long.
</div>
`}</code></pre>
    <h3>{`Form note with an error`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<label class="tp-label tp-label--bad-news" for="input-2781013281343234">Email</label>
<input
    type="email"
    class="tp-text-input tp-text-input--bad-news"
    defaultValue="example@example.com"
    id="input-2781013281343234"
    aria-describedby="email-form-note"
/>
<div id="email-form-note" class="tp-form-note tp-form-note--bad-news">
    This email address is already associated with an account.
</div>
`}</code></pre>
    <ComponentFooter data={props.data} mdxType="ComponentFooter" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      